export enum PreviewMode {
    Normal,
    MatCap,
    Wireframe,
    VertexColor,
    Textured,
    Normals,
}
